<script setup lang="ts">
import { useModal } from '@/composables/useModalStack'
import { useI18n } from '@/i18n'
import { BUNDLED_FONTS } from '@/text/fonts'

const emit = defineEmits<{ close: [] }>()
useModal('about')
const { t } = useI18n()
const version = __APP_VERSION__
const slug = (f: string) => f.toLowerCase().replace(/\s+/g, '-')
</script>

<template>
  <div class="modal-backdrop" @pointerdown.self="emit('close')">
    <div class="modal" @keydown.esc="emit('close')">
      <h2>{{ t('app.name') }}</h2>
      <p>{{ t('about.body', { version }) }}</p>
      <p class="muted small">
        {{ t('about.fonts') }}
        <template v-for="(f, i) in BUNDLED_FONTS" :key="f"><template v-if="i"> · </template><a :href="`/fonts/${slug(f)}/OFL.txt`" target="_blank" rel="noopener">{{ f }}</a></template>
      </p>
      <p class="muted"><a href="https://github.com/clostridium81/browser_photo_editor" target="_blank" rel="noopener">GitHub</a> · <a href="https://photo.jinchi-lab.com/" target="_blank" rel="noopener">photo.jinchi-lab.com</a></p>
      <div class="actions"><button class="primary" @click="emit('close')">{{ t('dialog.ok') }}</button></div>
    </div>
  </div>
</template>

<style scoped>
a {
  color: var(--accent-hi);
}
.small {
  font-size: 12px;
  line-height: 1.6;
}
</style>
